// extracted by mini-css-extract-plugin
export default {"menu":"MainMenu_menu__kYn0u","item":"MainMenu_item__jffes"};